import config from 'config'
import RoutingMenu from 'LIBRARY/CommonResources/RoutingMenu/RoutingMenu'
import React from 'react'
import StudentIssuedResources from './StudentIssuedResource.js'
import FacultyIssuedResources from './FacultyIssuedResources'

export const UserIssuedResources = () => {
  return (
    <>
      <RoutingMenu activeScreen="UserIssuedResources" />
      <div className=''>
        {/* <iframe
          src={`${config.RootUrl}/faculty/library/view/myIsssuedResource/myIsssuedResourceList.php?isIframe=true`}
          className="iframe col-md-12" >
        </iframe> */}

        {
          config.account == "faculty" ?
            <FacultyIssuedResources />
            // <iframe
            //   src={`${config.RootUrl}/faculty/library/view/myIsssuedResource/myIsssuedResourceList.php?isIframe=true`}
            //   className="iframe col-md-12" >
            // </iframe>
            :
            <StudentIssuedResources />
          // <iframe
          //   src={`${config.RootUrl}/student/library/view/myIsssuedResource/myIsssuedResourceList.php?isIframe=true`}
          //   className="iframe col-md-12" >
          // </iframe>
        }
      </div>
    </>
  )
}
